import { IFeatureFlagsData } from './types';

const actions = {
  FETCH_FEATURE_FLAGS_REQUEST: 'FEATURE_FLAGS_FETCH_REQUEST',
  FETCH_FEATURE_FLAGS_SUCCESS: 'FEATURE_FLAGS_FETCH_SUCCESS',
  FETCH_FEATURE_FLAGS_ERROR: 'FEATURE_FLAGS_FETCH_ERROR',

  fetchFeatureFlags: () => ({
    type: actions.FETCH_FEATURE_FLAGS_REQUEST,
  }),

  fetchFeatureFlagsSuccess: (data: IFeatureFlagsData) => ({
    type: actions.FETCH_FEATURE_FLAGS_SUCCESS,
    payload: data,
  }),

  fetchFeatureFlagsError: () => ({
    type: actions.FETCH_FEATURE_FLAGS_ERROR,
  }),
};

export default actions;
